export const sortString = (a, b) => {
  if (!!a && !!b) {
    return a.localeCompare(b);
  } else if (!!a && !b) {
    return 1;
  } else if (!a && !!b) {
    return -1;
  } else {
    return 0;
  }
};
export const sortNumber = (a, b) => {
  return a - b;
};
export const sortDate = (a, b) => sortNumber(a.valueOf(), b.valueOf());
